<template>
	<!-- // componente que se usa para crear o editar un usuario -->
	<CRow class="justify-content-center">
		<CCol md="12">
			<CCard>
				<CCardHeader style="background: #97ca3d;color: #000000;">
					<h4>{{ tittleForm }}</h4>
				</CCardHeader>
				<CCardBody>
					<ValidationObserver ref="observer" v-slot="{ invalid }">
						<CAlert v-if="showAlertInvalid" color="danger"
							>Oops!! El formulario tiene algún error. Por favor
							verifique los campos.</CAlert
						>
						<CForm>
							<ValidationProvider
								name="Nombre"
								rules="required|min:6"
								v-slot="{ valid, errors, touched }"
							>
								<CInput
									v-model="dataUser.name"
									placeholder="Nombre"
									label="Nombre del Usuario"
									:isValid="
										touched && !valid
											? valid
											: touched && valid
											? valid
											: null
									"
								>
									<template #prepend-content>
										<i class="fas fa-user-tie"></i
									></template>
									<template #invalid-feedback>
										<span class="invalid-feedback">{{
											errors[0]
										}}</span>
									</template>
									<template #description>
										<span class="style-description"
											>Ingresa el nombre completo del
											usuario.</span
										>
									</template>
								</CInput>
							</ValidationProvider>
							<ValidationProvider
								name="E-Mail"
								rules="required|customEmail"
								v-slot="{ valid, errors, touched }"
							>
								<CInput
									v-model="dataUser.email"
									placeholder="E-Mail"
									label="E-Mail"
									:isValid="
										touched && !valid
											? valid
											: touched && valid
											? valid
											: null
									"
								>
									<template #prepend-content>
										<i class="fas fa-at"></i>
									</template>
									<template #invalid-feedback>
										<span class="invalid-feedback">{{
											errors[0]
										}}</span>
									</template>
									<template #description>
										<span class="style-description"
											>Este será el login para ingresar al
											sistema.</span
										>
									</template>
								</CInput>
							</ValidationProvider>
							<ValidationProvider
								v-if="!editUser"
								name="Contraseña"
								rules="required|min:6"
								v-slot="{ valid, errors, touched }"
								vid="password"
							>
								<CInput
									v-model="dataUser.password"
									placeholder="Contraseña"
									type="password"
									autocomplete="new-password"
									label="Contraseña"
									:isValid="
										touched && !valid
											? valid
											: touched && valid
											? valid
											: null
									"
								>
									<template #prepend-content>
										<i class="fas fa-lock"></i
									></template>
									<template #invalid-feedback>
										<span class="invalid-feedback">{{
											errors[0]
										}}</span>
									</template>
								</CInput>
							</ValidationProvider>
							<ValidationProvider
								v-else
								name="Contraseña"
								rules="min:6"
								v-slot="{ valid, errors, touched }"
								vid="password"
							>
								<CInput
									v-model="dataUser.password"
									placeholder="Contraseña"
									type="password"
									autocomplete="new-password"
									label="Contraseña"
									:isValid="
										touched && !valid
											? valid
											: touched && valid
											? valid
											: null
									"
								>
									<template #prepend-content>
										<i class="fas fa-lock"></i
									></template>
									<template #invalid-feedback>
										<span class="invalid-feedback">{{
											errors[0]
										}}</span>
									</template>
								</CInput>
							</ValidationProvider>
							<ValidationProvider
								v-if="!editUser"
								name="Contraseña"
								rules="required|confirmed:password|min:6"
								v-slot="{ valid, errors, touched }"
							>
								<CInput
									v-model="dataUser.password_confirmation"
									placeholder="Repite la contraseña"
									type="password"
									autocomplete="new-password"
									label="Repetir Contraseña"
									class="mb-4"
									:isValid="
										touched && !valid
											? valid
											: touched && valid
											? valid
											: null
									"
								>
									<template #prepend-content>
										<i class="fas fa-lock"></i
									></template>
									<template #invalid-feedback>
										<span class="invalid-feedback">{{
											errors[0]
										}}</span>
									</template>
								</CInput>
							</ValidationProvider>
							<ValidationProvider
								v-else
								name="Contraseña"
								rules="confirmed:password|min:6"
								v-slot="{ valid, errors, touched }"
							>
								<CInput
									v-model="dataUser.password_confirmation"
									placeholder="Repite la contraseña"
									type="password"
									autocomplete="new-password"
									label="Repetir Contraseña"
									class="mb-4"
									:isValid="
										touched && !valid
											? valid
											: touched && valid
											? valid
											: null
									"
								>
									<template #prepend-content>
										<i class="fas fa-lock"></i
									></template>
									<template #invalid-feedback>
										<span class="invalid-feedback">{{
											errors[0]
										}}</span>
									</template>
								</CInput>
							</ValidationProvider>
							<div role="group" class="form-group">
								<label for="urb">Perfil del Usuario</label>
								<multiselect
									:preselect-first="true"
									@select="changeProfile"
									v-if="allProfiles != null"
									v-model="userSelectedProfile"
									:allow-empty="false"
									track-by="idProfiles"
									label="name"
									:options="allProfiles"
									:searchable="true"
									:close-on-select="true"
									:show-labels="false"
									placeholder="Seleccione"
								>
									<span slot="noResult"
										>Oops! No se encontró la opción
										deseada</span
									>
								</multiselect>
							</div>
							<!-- <div role="group" class="form-group">
                                <label for="">Imagen para el perfil (Opcional)</label>
                                <b-form-file accept="image/jpeg, image/png, image/gif" browse-text="Subir imagen"
                                    drop-placeholder="Suelta el archivo aquí ..."
                                    placeholder="Elije un archivo o suéltalo aquí ...">
                                    <template slot="file-name" slot-scope="{ names }">
                                        <b-badge variant="success">{{ names[0] }}</b-badge>
                                    </template>
                                </b-form-file>
                            </div> -->
							<ValidationProvider
								v-if="!editUser"
								name="Id del usuario en el SCC"
								rules="required"
								v-slot="{ valid, errors, touched }"
							>
								<CInput
									v-model="dataUser.idUsers"
									placeholder="Id del usuario en el SCC "
									label="Id del usuario en el SCC"
									:isValid="
										touched && !valid
											? valid
											: touched && valid
											? valid
											: null
									"
								>
									<template #prepend-content>
										<i
											class="fas fa-id-badge"
										></i></template
									><template #invalid-feedback>
										<span class="invalid-feedback">{{
											errors[0]
										}}</span>
									</template>
									<template #description>
										<span class="style-description"
											>Por favor recuerda verificar que el
											id corresponde al mismo usuario en
											el SCC.</span
										>
									</template>
								</CInput>
							</ValidationProvider>
							<CInput
								v-else
								disabled
								v-model="dataUser.idUsers"
								placeholder="Id del usuario en el SCC "
								label="Id del usuario en el SCC"
							>
								<template #prepend-content>
									<i class="fas fa-id-badge"></i
								></template>
							</CInput>
							<!-- abreviatura del scc -->
							<ValidationProvider
								name="Abreviatura del Usuario en el SCC"
								rules="required|min:3|max:3|alpha"
								v-slot="{ valid, errors, touched }"
							>
								<CInput
									v-model="dataUser.abbreviationSCC"
									@keyup="uppercase"
									placeholder="Abreviatura del Usuario en el SCC"
									label="Abreviatura del Usuario en el SCC"
									:isValid="
										touched && !valid
											? valid
											: touched && valid
											? valid
											: null
									"
									maxlength="3"
								>
									<template #invalid-feedback>
										<span class="invalid-feedback">{{
											errors[0]
										}}</span>
									</template>
									<template #description>
										<span class="style-description"
											>Por favor recuerda verificar la
											abreviatura corresponde al mismo
											usuario en el SCC.</span
										>
									</template>
								</CInput>
							</ValidationProvider>
						</CForm>
					</ValidationObserver>
					<CRow class="content-center">
						<CCol sm="6">
							<b-button
								@click="goToConsultUsers"
								pill
								size="lg"
								variant="warning"
								>Cancelar</b-button
							>
						</CCol>
						<br />
						<CCol sm="6">
							<b-button
								v-if="!this.editUser"
								@click="showModalConfirm"
								pill
								size="lg"
								variant="success"
							>
								Guardar</b-button
							>
							<b-button
								v-else
								@click="saveUserEdited"
								pill
								size="lg"
								variant="success"
								>Guardar</b-button
							>
						</CCol>
					</CRow>
				</CCardBody>
				<!-- <CCardFooter>
                    <CRow class="content-center">
                        <CCol sm="6">
                            <b-button @click="goToConsultUsers" pill size="lg" variant="warning">Cancelar</b-button>
                        </CCol>
                        <br>
                        <CCol sm="6">
                            <b-button v-if="!this.editUser" @click="showModalConfirm" pill size="lg" variant="success">
                                Guardar</b-button>
                            <b-button v-else @click="saveUserEdited" pill size="lg" variant="success">Guardar</b-button>
                        </CCol>
                    </CRow>
                </CCardFooter> -->
			</CCard>
		</CCol>
		<!-- modal para confirmar que el id del scc es el correcto al guardar un usuario nuevo -->
		<CModal
			:show.sync="modalConfirmSave"
			:close-on-backdrop="false"
			:centered="true"
			title="Crear Nuevo Usuario"
			size="lg"
			color="info"
			style="text-align:justify;"
		>
			<CRow>
				<CCol>
					<span
						>Estas registrando un usuario con el id de usuario en el
						SCC <b>{{ dataUser.idUsers }}</b></span
					>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol>
					<span>
						Por favor confirma que el ID ingresando corresponde al
						mismo ID del usuario en el SCC ya que una vez creado no
						podrás editar este ID, por lo que deberás eliminar el
						usuario y crearlo nuevamente.
					</span>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol>
					<span>
						Si el ID es el correcto puedes continuar guardando el
						usuario haciendo clic en <b>Confirmar</b>, de lo
						contrario puedes hacer clic en <b>Cambiar ID</b> para
						que puedas editarlo.
					</span>
				</CCol>
			</CRow>
			<template #header>
				<h6 class="modal-title">Crear Nuevo Usuario</h6>
			</template>
			<template #footer>
				<b-button
					@click="saveNewUser"
					pill
					variant="success"
					size="lg"
					class="mr-1"
					>Confirmar
				</b-button>
				<b-button
					@click="modalConfirmSave = false"
					pill
					variant="info"
					size="lg"
					class="mr-1"
					>Cambiar ID
				</b-button>
			</template>
		</CModal>
		<!-- modal para mostrar errores -->
		<CModal
			:show.sync="modalForErrors"
			:close-on-backdrop="true"
			:centered="true"
			title="Oops!! Ocurrió un error!!"
			size="lg"
			color="danger"
			style="text-align:justify;"
		>
			<CRow>
				<CCol v-if= "typeof errorsFound !== 'string'">
					<div
						v-for="(value, key, index) in errorsFound"
						:key="`${key}-${index}`"
					>
						<!-- <span>{{value}}</span> -->
						<div v-for="item in value" :key="item.id">
							<span
								><b>{{ item }}</b></span
							><br />
						</div>
					</div>
					<br />
				</CCol>
				<CCol v-else>
					<span
						><b>{{ errorsFound }}</b></span
					><br /><br />
				</CCol>
			</CRow>
			<CRow>
				<CCol>
					<span>
						Por favor cierra esta modal y verifica los datos
						ingresados en el formulario
					</span>
				</CCol>
			</CRow>
			<template #header>
				<h6 class="modal-title">Oops!! Ocurrió un error!!</h6>
				<CButtonClose
					@click="modalForErrors = false"
					class="text-white"
				/>
			</template>
			<template #footer>
				<b-button
					@click="modalForErrors = false"
					pill
					variant="warning"
					size="lg"
					class="mr-1"
					>Cerrar
				</b-button>
			</template>
		</CModal>
		<!-- modal de confirmacion al guardar exitosamente -->
		<CModal
			:show.sync="modalSuccessSend"
			:close-on-backdrop="false"
			:centered="true"
			title="Guardado exitosamente!!"
			size="lg"
			color="success"
			style="text-align:justify;"
		>
			<CRow>
				<CCol>
					<span
						>Se guardo con éxito la información del usuario:
						<b>{{ dataUser.name }}</b></span
					>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol>
					<span>
						Recuerda que debe validar su acceso al sistema mediante
						el link enviado por el sistema a su e-mail:
						<b>{{ dataUser.email }}</b
						>.
					</span>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol>
					<span>
						Una vez valide su acceso podrá ingresar al sistema con
						su e-mail y clave.
					</span>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol>
					<span>
						Puedes cerrar esta modal para ir al modulo de consulta
						de usuarios.
					</span>
				</CCol>
			</CRow>
			<template #header>
				<h6 class="modal-title">Guardado exitosamente!!</h6>
				<CButtonClose @click="goToConsultUsers" class="text-white" />
			</template>
			<template #footer>
				<b-button
					@click="goToConsultUsers"
					pill
					variant="success"
					size="lg"
					class="mr-1"
					>Cerrar
				</b-button>
			</template>
		</CModal>
	</CRow>
</template>

<script>
	import '../validations/validationsForm';
	import adminUsers from '../functions/functionsAdminUsers';
	/**Componente usado para crear o editar un usuario del sistema.
	 * Contiene el formulario para ingresar sus datos */
	export default {
		name: 'CreateUser',
		props: {
			/**Prop para inidcar si se esta editando un usuario
			 * Por defecto es false
			 */
			editUser: {
				type: Boolean,
				default: function() {
					return false;
				},
			},
			//prop para el titulo del formulario
			tittleForm: {
				type: String,
				default: function() {
					return 'Crear Nuevo Usuario';
				},
			},
			//prop para el id del usuario cuando se usa el componente para editar los datos
			idUser: {
				type: String,
				default: function() {
					return '';
				},
			},
		},
		data() {
			return {
				dataUser: {
					idUsers: '',
					name: '',
					email: '',
					password: '',
					password_confirmation: '',
					idprofiles: '',
					photoOption: 'G',
					notification: 0,
					abbreviationSCC: '',
				},
				userSelectedProfile: null,
				userImage: null,
				showAlertInvalid: false,
				allProfiles: null,
				modalConfirmSave: false,
				modalForErrors: false,
				confirmedId: false,
				errorsFound: [],
				modalSuccessSend: false,
			};
		},
		created() {
			let loader = this.$loading.show();
			adminUsers
				.getAllProfiles()
				.then((response) => {
					this.allProfiles = response.filter(
						(el) => el.idProfiles !== 1
					);
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					loader.hide();
				});
			if (this.editUser) {
				adminUsers
					.getSpecificUser(this.idUser)
					.then((response) => {
						this.dataUser.name = response[0].name;
						this.dataUser.email = response[0].email;
						this.dataUser.idUsers = response[0].idUsers;
						this.dataUser.idprofiles = response[0].idprofiles;
						this.dataUser.notification = response[0].notification;
						this.userSelectedProfile = response[0].profile;
						this.dataUser.abbreviationSCC =
							response[0].abbreviationSCC;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			}
		},
		methods: {
			changeProfile(selectedProfile) {
				this.dataUser.idprofiles = selectedProfile.idProfiles;
			},
			goToConsultUsers() {
				this.$router.push({
					name: 'AllUsers',
				});
			},
			async showModalConfirm() {
				const isValid = await this.$refs.observer.validate();
				this.showAlertInvalid = !isValid ? true : false;
				if (isValid) {
					this.modalConfirmSave = true;
				}
			},
			saveNewUser() {
				let loader = this.$loading.show();
				adminUsers
					.addNewUser(this.dataUser)
					.then((response) => {
						this.modalSuccessSend = true;
						this.modalConfirmSave = false;
					})
					.catch((error) => {
						console.log(error);
						let errorCode = error.response.data.code;
						switch (errorCode) {
							case 401:
								this.$router.push({
									name: 'Login',
								});
								break;
							case 422:
								this.errorsFound = error.response.data.error;
								this.modalConfirmSave = false;
								this.modalForErrors = true;
								break;
						}
					})
					.finally(() => {
						loader.hide();
					});
			},
			async saveUserEdited() {
				const isValid = await this.$refs.observer.validate();
				this.showAlertInvalid = !isValid ? true : false;
				let objAsArray = Object.entries(this.dataUser);
				let arrayFiltered = objAsArray.filter(
					([key, value]) => value !== ''
				);
				let objForPost = Object.fromEntries(arrayFiltered);
				console.log(objForPost);
				if (isValid) {
					let loader = this.$loading.show();
					adminUsers
						.editUser(objForPost)
						.then((response) => {
							this.modalSuccessSend = true;
						})
						.catch((error) => {
							console.log(error);
							let errorCode = error.response.data.code;
							switch (errorCode) {
								case 401:
									this.$router.push({
										name: 'Login',
									});
									break;
								case 422:
									console.log(
										typeof error.response.data.error
									);
									// if (typeof error.response.data.error == 'string' ) {
									// 	console.log('hola');
									// 	this.errorsFound['test'] =  error.response.data.error;
									// }
									this.errorsFound =
										error.response.data.error;
									this.modalConfirmSave = false;
									this.modalForErrors = true;
									break;
							}
						})
						.finally(() => {
							loader.hide();
						});
				}
			},
			uppercase() {
				this.dataUser.abbreviationSCC = this.dataUser.abbreviationSCC.toUpperCase();
			},
		},
	};
</script>
